import React from "react";
//#region types
import { DimensionsAutocompleteInputProps } from "models/propTypes/dimensionPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import MultipleAutoCompleteInput from "../multipleAutoCompleteInput";
//#endregion
import { StringHelper, DimensionHelper } from "utils/helpers";

const DimensionsAutoCompleteInput: React.FC<DimensionsAutocompleteInputProps> = (props) => {
  const { dimensionType, disabled, enableSingleSelectionMode, optional } = props;

  return (
    <MultipleAutoCompleteInput
      name={dimensionType.name}
      key={dimensionType.id}
      suggestedItems={dimensionType.suggestions}
      items={dimensionType.all}
      value={dimensionType.selectedDimensions}
      onItemsSelect={props.onItemsSelect}
      onItemDelete={props.onSelectionDelete}
      label={StringHelper.getFormattedMessageWithOptionalSuffix(
        TranslationKeys.Common.SearchDimension,
        optional ?? false,
        undefined,
        { dimensionType: DimensionHelper.getDimensionTypeText(dimensionType.type, dimensionType.name).toLowerCase() }
      )}
      disabled={disabled}
      forceSingleSelection={enableSingleSelectionMode}
      error={props.error}
    />
  );
};

export default DimensionsAutoCompleteInput;
